import React, { useState } from 'react';
import { ShieldCheck, CreditCard, Zap } from 'lucide-react';
type PlanOption = 'standard' | 'complete';
export function PricingSection() {
  const [selected, setSelected] = useState<PlanOption>('complete');
  const links: Record<PlanOption, string> = {
    standard: 'https://pagos.recursosfitness.shop/cart/44108714901601:1',
    complete: 'https://pagos.recursosfitness.shop/cart/44108715622497:1'
  };
  return <section id="pricing" className="py-10 md:py-20 bg-neutral-950" data-id="element-192">
      <div className="container mx-auto px-4" data-id="element-193">
        <div className="text-center mb-6 md:mb-12" data-id="element-194">
          <h2 className="text-2xl md:text-5xl font-black text-white mb-2 md:mb-4" data-id="element-195">
            Elegí tu Ritmos Latinos Resuelto:
          </h2>
          <p className="text-sm md:text-xl text-neutral-400" data-id="element-196">
            Las dos opciones incluyen los 6 bonos estratégicos completos
          </p>
        </div>

        <div className="max-w-xl mx-auto space-y-3" data-id="element-197">
          {/* Pack Completo - Highlighted */}
          <button onClick={() => setSelected('complete')} className={`w-full text-left rounded-xl md:rounded-2xl p-4 md:p-5 border-2 transition-all duration-200 relative ${selected === 'complete' ? 'border-amber-500 bg-neutral-900 shadow-[0_0_30px_rgba(245,158,11,0.12)]' : 'border-neutral-800 bg-neutral-900/50 hover:border-neutral-700'}`} data-id="element-198">
            <div className="flex items-start gap-3" data-id="element-199">
              {/* Radio */}
              <div className={`mt-1 w-5 h-5 rounded-full border-2 shrink-0 flex items-center justify-center ${selected === 'complete' ? 'border-amber-500' : 'border-neutral-600'}`} data-id="element-200">
                {selected === 'complete' && <div className="w-2.5 h-2.5 rounded-full bg-amber-500" data-id="element-201" />}
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0" data-id="element-202">
                <div className="flex items-center gap-2 mb-1" data-id="element-203">
                  <span className="text-lg md:text-xl" data-id="element-204">🏆</span>
                  <h3 className="text-base md:text-xl font-black text-white" data-id="element-205">
                    PACK COMPLETO
                  </h3>
                </div>
                <div className="flex flex-wrap items-center gap-2 mb-1.5" data-id="element-206">
                  <span className="px-2 py-0.5 bg-amber-500 text-neutral-950 text-[10px] md:text-xs font-black rounded uppercase" data-id="element-207">
                    MÁS ELEGIDO
                  </span>
                  <span className="px-2 py-0.5 bg-amber-500/20 text-amber-400 text-[10px] md:text-xs font-bold rounded border border-amber-500/30" data-id="element-208">
                    AHORRÁS $16.000
                  </span>
                </div>
                <p className="text-neutral-400 text-xs md:text-sm" data-id="element-209">
                  6 Tomos + 6 Bonos + Ritmos Pro Avanzado™
                </p>
              </div>

              {/* Price */}
              <div className="text-right shrink-0" data-id="element-210">
                <div className="text-neutral-500 line-through text-xs md:text-sm" data-id="element-211">
                  $43.990
                </div>
                <div className="text-2xl md:text-3xl font-black text-amber-500" data-id="element-212">
                  $27.990
                </div>
              </div>
            </div>
          </button>

          {/* Standard */}
          <button onClick={() => setSelected('standard')} className={`w-full text-left rounded-xl md:rounded-2xl p-4 md:p-5 border-2 transition-all duration-200 ${selected === 'standard' ? 'border-amber-500 bg-neutral-900 shadow-[0_0_30px_rgba(245,158,11,0.12)]' : 'border-neutral-800 bg-neutral-900/50 hover:border-neutral-700'}`} data-id="element-213">
            <div className="flex items-start gap-3" data-id="element-214">
              {/* Radio */}
              <div className={`mt-1 w-5 h-5 rounded-full border-2 shrink-0 flex items-center justify-center ${selected === 'standard' ? 'border-amber-500' : 'border-neutral-600'}`} data-id="element-215">
                {selected === 'standard' && <div className="w-2.5 h-2.5 rounded-full bg-amber-500" data-id="element-216" />}
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0" data-id="element-217">
                <div className="flex items-center gap-2 mb-1" data-id="element-218">
                  <span className="text-lg md:text-xl" data-id="element-219">📘</span>
                  <h3 className="text-base md:text-xl font-black text-white" data-id="element-220">
                    RITMOS LATINOS RESUELTO
                  </h3>
                </div>
                <p className="text-neutral-400 text-xs md:text-sm" data-id="element-221">
                  6 Tomos + 6 Bonos
                </p>
              </div>

              {/* Price */}
              <div className="text-right shrink-0" data-id="element-222">
                <div className="text-neutral-500 line-through text-xs md:text-sm" data-id="element-223">
                  $34.990
                </div>
                <div className="text-2xl md:text-3xl font-black text-white" data-id="element-224">
                  $19.990
                </div>
              </div>
            </div>
          </button>

          {/* CTA Button */}
          <a href={links[selected]} target="_blank" rel="noopener noreferrer" className="block w-full py-4 md:py-5 px-6 rounded-xl bg-amber-500 text-neutral-950 font-black text-base md:text-lg text-center hover:bg-amber-400 transition-all shadow-lg hover:shadow-amber-500/25 hover:-translate-y-0.5 mt-4" data-id="element-225">
            {selected === 'complete' ? 'SÍ, QUIERO PACK COMPLETO →' : 'SÍ, QUIERO MI RITMOS LATINOS RESUELTO →'}
          </a>

          <p className="text-center text-xs md:text-sm text-neutral-400 font-medium italic" data-id="element-226">
            {selected === 'complete' ? 'La opción más elegida por profes que enseñan con sistema total' : 'Incluye los 6 tomos + 6 bonos estratégicos'}
          </p>

          {/* Trust Badges */}
          <div className="flex flex-wrap justify-center items-center gap-x-4 md:gap-x-6 gap-y-2 pt-4 border-t border-neutral-800 mt-4 text-[11px] md:text-sm text-neutral-400" data-id="element-227">
            <span className="flex items-center gap-1.5" data-id="element-228">
              <span data-id="element-229">🔒</span> Pago seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-230">
              <Zap className="w-3.5 h-3.5" data-id="element-231" /> Acceso en 5 min
            </span>
            <span className="flex items-center gap-1.5" data-id="element-232">
              <ShieldCheck className="w-3.5 h-3.5" data-id="element-233" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-1.5" data-id="element-234">
              <CreditCard className="w-3.5 h-3.5" data-id="element-235" /> Mercado Pago
            </span>
          </div>
        </div>
      </div>
    </section>;
}